import { NAVIGATION_FORM_ERRORS } from 'core/constants/navigation.constants';
import { ENavigationFormError } from 'core/model/enums/navigation.enum';
import { TNavigationTreeDetailCreateForm } from 'core/model/interfaces/navigation';
import { IServiceErrorContent } from 'core/model/interfaces/service.interface';
import { apiService } from 'core/services';
import type { TSliceExtraReducer } from 'core/store';
import { createAppAsyncThunk } from 'core/store/store.helpers';
import { handleSpecificErrors } from 'shared/utils/errors.utils';
import { notificationService } from 'shared/utils/notification.utils';
import { SLICE_NAMESPACE } from '../../constants';
import { getUnexpectedErrorMessages } from '../../navigation.utils';
import { INavigationState } from '../../types';

export const createNavigationTree = createAppAsyncThunk(
  `${SLICE_NAMESPACE}/createNavigationTree`,
  async ({ data }: { data: TNavigationTreeDetailCreateForm }, { rejectWithValue }) => {
    try {
      await apiService.navigation.createNavigationTree(data);
      notificationService.global.success('Árbol creado correctamente.');
    } catch (e) {
      const handledError = handleSpecificErrors(
        e,
        getUnexpectedErrorMessages('trees', 'create'),
        NAVIGATION_FORM_ERRORS,
      );
      if (handledError) return rejectWithValue(handledError);

      throw e;
    }
  },
);

export const createNavigationTreeReducer: TSliceExtraReducer<INavigationState> = builder =>
  builder
    .addCase(createNavigationTree.pending, state => {
      state.form.loading = true;
      state.form.success = false;
      state.form.errors = {};
    })
    .addCase(createNavigationTree.rejected, (state, action) => {
      state.form.loading = false;
      state.form.success = false;

      const errorContent = action.payload as IServiceErrorContent;
      if (errorContent?.code === ENavigationFormError.familyOrderFile) {
        state.form.errors.familyOrderFile = errorContent.details.join('\n\n');
      }
    })
    .addCase(createNavigationTree.fulfilled, state => {
      state.form.loading = false;
      state.form.success = true;
      state.form.errors = {};
    });
